import HeaderMenus from './HeaderMenus'
import MenuDrawer from './MenuDrawer'
import ToolBar from '@material-ui/core/Toolbar'
import { useState, useCallback } from 'react'
import logo from '../assets/logo.png'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import styled from 'styled-components'

const Header = () => {
    const dispatch = useDispatch()

    const [open, setOpen] = useState(false);

    const handleDrawerToggle = useCallback((event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpen(!open)
    }, [setOpen, open]);

    return (
        
        <div style={{flexGrow:1}}>
            <HeaderBar>
                <StyledToolBar>
                    <div onClick={()=>dispatch(push('/'))} style={{cursor: 'pointer'}}>
                        <LogoImage src={logo} alt="To The Top Logo" />
                    </div>
                    <div style={{marginLeft: 'auto'}} >
                        <HeaderMenus handleDrawerToggle={handleDrawerToggle}/>
                    </div>
                </StyledToolBar>
                <MenuDrawer open={open} onClose={handleDrawerToggle} />
            </HeaderBar>
        </div>
        
    )
}

export default Header

const HeaderBar = styled.div`
    width: 100%;
    height: 64px;
    position: fixed;
    z-index: 10;
    background-color:#000;
`

const LogoImage = styled.img`
    width: 128px;
    position: absolute;
    top: 0;
    @media screen and (max-width:768px){
        width: 96px;
        left: 0;
    }
`
const StyledToolBar = styled(ToolBar)`
    margin: 0 auto;
    max-width: 1080px;
    width: 100%;
    background-color: #000;
`